import type { RenderContext, VideoFrame } from '../../types';
import { BaseEffect } from '../base';
import { stableEffectSeed, withOverlay } from './composite';
import { buildSnowParticles, drawSnow } from '../../particles/engine';

const DEFAULTS = { density: 0.5, wind: 0.2, flakeSize: 0.6 };

export class SnowEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'snow', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    return this.renderCpu(frame, params, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const seed = stableEffectSeed(context, this.id);
    const particles = buildSnowParticles(
      frame.width, frame.height, params.density, params.wind, params.flakeSize,
      context.frameIndex, seed,
    );
    return withOverlay(frame, (ctx) => drawSnow(ctx, particles), 'lighter');
  }
}
